import { render, staticRenderFns } from "./DislikeBtn.vue?vue&type=template&id=0f65b9a2"
import script from "./DislikeBtn.vue?vue&type=script&lang=js"
export * from "./DislikeBtn.vue?vue&type=script&lang=js"
import style0 from "./DislikeBtn.vue?vue&type=style&index=0&id=0f65b9a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports